export const alertConstant = {
    SHOW_ERROR_MESSAGE:"SHOW_ERROR_MESSAGE",
    SHOW_NETWORK_ERROR_API_MESSAGE:"SHOW_NETWORK_ERROR_API_MESSAGE",
    RESET_ERROR_MESSAGE:"RESET_ERROR_MESSAGE",
    RESET_NETWORK_ERROR_API_MESSAGE:"RESET_NETWORK_ERROR_API_MESSAGE",
 };